import { api } from "./api";

export default class ClientService {
  async findById(id: number) {
    try {
      const response = await api.get(`/api/clients/${id}`);
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  }
}
